import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_GREEN } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track17ABlue = ({ state, workState, onLabelClick, id }) => (
	<g id="Track17ABlue" transform="translate(1864.000000, 373.000000)" className="track">
		<path
			d="M0,-5.68434189e-14 L13.8327673,9.29298366 C17.9218072,12.0400392 22.3943579,14.1677413 27.1054823,15.6071398 L52.3015053,23.6282735 M63.341933,26.6785287 L182.062215,62.9513534 C186.051781,64.1702928 190.178212,64.8851594 194.345317,65.079289 L214,65.9949263"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_GREEN)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow transform="translate(50.309574, 22.879157) rotate(-161.000000) translate(-50.309574, -22.879157) "
								points="54.3095743 30.8791573 46.3095743 22.8791573 54.3095743 14.8791573"
								strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_GREEN)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, id || 'Track17ABlue')}
			coords="87.886719, 16.000000"
			text="17A"
			textCoordsX="7.97607422"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_GREEN)}
		/>
	</g>
);

Track17ABlue.propTypes = trackPropTypes;
export default Track17ABlue;